import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { configService } from '../services/api';

export default function Login() {
  const { login } = useAuth();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [logoUrl, setLogoUrl] = useState(null);

  useEffect(() => {
    const url = configService.getLogoUrl();
    fetch(url).then(r => { if (r.ok) setLogoUrl(url + '?t=' + Date.now()); }).catch(()=>{});
  }, []);

  const handleSubmit = async () => {
    setError(''); setLoading(true);
    try {
      await login(form.username, form.password);
    } catch (err) {
      setError('Usuario o contraseña incorrectos');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:'100vh', background:'#f8f5f0', display:'flex', alignItems:'center', justifyContent:'center' }}>
      <div style={{ background:'#fff', borderRadius:14, boxShadow:'0 4px 24px rgba(0,0,0,0.12)', padding:40, width:320 }}>
        <div style={{ textAlign:'center', marginBottom:28 }}>
          {logoUrl
            ? <img src={logoUrl} alt="Logo" style={{ height:80, objectFit:'contain', marginBottom:10 }}/>
            : <div style={{ fontSize:40 }}>🪑</div>
          }
          <div style={{ fontWeight:800, fontSize:22, color:'#5c3d2e' }}>Muebles Terrasol</div>
          <div style={{ color:'#999', fontSize:13 }}>Sistema de Gestión</div>
        </div>
        <label style={{ display:'block', marginBottom:4, fontWeight:600, fontSize:13, color:'#555' }}>Usuario</label>
        <input
          style={{ width:'100%', padding:'9px 12px', border:'1px solid #ddd', borderRadius:7, fontSize:14, boxSizing:'border-box', marginBottom:12 }}
          placeholder="Ej: admin" value={form.username}
          onChange={e => setForm(p => ({ ...p, username: e.target.value }))}
          onKeyDown={e => e.key === 'Enter' && handleSubmit()}
        />
        <label style={{ display:'block', marginBottom:4, fontWeight:600, fontSize:13, color:'#555' }}>Contraseña</label>
        <input
          style={{ width:'100%', padding:'9px 12px', border:'1px solid #ddd', borderRadius:7, fontSize:14, boxSizing:'border-box', marginBottom:12 }}
          type="password" placeholder="••••••••" value={form.password}
          onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
          onKeyDown={e => e.key === 'Enter' && handleSubmit()}
        />
        {error && <div style={{ color:'#c0392b', fontSize:13, marginBottom:10 }}>⚠ {error}</div>}
        <button
          style={{ width:'100%', background:'#5c3d2e', color:'#fff', border:'none', padding:'11px', borderRadius:8, cursor:'pointer', fontSize:15, fontWeight:600, opacity: loading ? 0.7 : 1 }}
          onClick={handleSubmit} disabled={loading}>
          {loading ? 'Ingresando...' : 'Ingresar'}
        </button>
      </div>
    </div>
  );
}
